import React, { useContext } from 'react'

import { LocaleContext } from '../locale/i18n'
import {
  PriceWithCurrency,
  PriceRangeWithCurrency,
} from '../locale/PriceWithCurrency'
import './PriceGroup.scss'

const PriceGroup = ({
  label,
  note,
  price,
  testId,
}: {
  label: string
  note?: string
  price: number | [number, number]
  testId?: string
}) => {
  const { t, locale } = useContext(LocaleContext)
  return (
    <div className="priceGroup">
      {label} ({t('pricing.noVat')}):
      <div className="priceGroup__row">
        <span className="priceGroup__price" data-test-id={testId}>
          {typeof price === 'number' ? (
            <PriceWithCurrency price={price} locale={locale} />
          ) : (
            <PriceRangeWithCurrency priceRange={price} locale={locale} />
          )}
        </span>
        {note}
      </div>
    </div>
  )
}

export default PriceGroup
